import { apiFetch } from '@/lib/api';
import { newestFirst } from '@/lib/sort';
import type { Localized } from '@/lib/localized';

// Public etkinlikler (yalnızca yayında olanlar — /api/public/events).
export type EventItem = {
  _id: string;
  title: Localized;
  description: Localized;
  date?: string;
  images?: string[];
  link?: string;
  organizer?: Localized;
  createdAt?: string;
  updatedAt?: string;
};

export function listEvents() {
  return apiFetch<{ records: EventItem[] }>('/api/public/events').then((r) => ({
    ...r,
    records: newestFirst(r.records),
  }));
}

export function getEvent(id: string) {
  return apiFetch<{ record: EventItem }>(`/api/public/events/${id}`);
}
